import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translations, type TranslationKey } from './translations';
import type { Language, TranslationValues } from './types';

export const LANGUAGE_STORAGE_KEY = 'sheriff_miniapp_language';
type I18n = { language: Language; setLanguage: (language: Language) => void; t: (key: TranslationKey, values?: TranslationValues) => string };
const I18nContext = createContext<I18n | null>(null);
const getPreferredLanguage = (): Language => {
  try { const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY); if (saved === 'ru' || saved === 'en' || saved === 'az') return saved; } catch { /* unavailable storage */ }
  const code = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || navigator.language;
  return code?.toLowerCase().startsWith('az') ? 'az' : code?.toLowerCase().startsWith('en') ? 'en' : 'ru';
};
export function I18nProvider({ children }: { children: React.ReactNode }) {
  const [language, setState] = useState<Language>(getPreferredLanguage);
  const setLanguage = (next: Language) => { setState(next); try { localStorage.setItem(LANGUAGE_STORAGE_KEY, next); } catch { /* optional */ } };
  const value = useMemo<I18n>(() => ({ language, setLanguage, t: (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.split(`{${name}}`).join(String(value)), translations[language][key]) }), [language]);
  useEffect(() => { document.documentElement.lang = language; }, [language]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}
export function useI18n() { const context = useContext(I18nContext); if (!context) throw new Error('useI18n must be used inside I18nProvider'); return context; }
